<template>
  <el-row :gutter="20" class="panel-group" type="flex">
    
    <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6" class="card-panel-col" v-for="(item,index) in countData" :key="index">
      <div class="card-panel">

        <div class="card-panel-icon-wrapper" :class="index == 0 ? 'icon-people' : index == '1' ? 'icon-message' : index == 2 ? 'icon-money' : 'icon-shopping'">
          <svg-icon :icon-class="item.svg" class-name="card-panel-icon" />
        </div>

        <div class="card-panel-description">
          <div class="data-box" v-for="(optionItem,optionIndex) in item.valueList" :key="optionIndex">
            <div class="card-panel-text" >{{optionItem.name}}</div>
            <el-tooltip :content="optionItem.name+'：'+optionItem.data" placement="bottom">
              <!-- 数据 -->
              <span class="card-panel-num" v-if="typeof(optionItem.data) == 'string'">{{optionItem.data}}</span>
              <count-to v-else :start-val="0" :end-val="optionItem.data" :duration="parseInt(2600 + 200 * optionIndex)" class="card-panel-num" />
            </el-tooltip>
            
          </div>
        </div>
      </div>
    </el-col>

  </el-row>
</template>

<script>
import CountTo from 'vue-count-to'

export default {
  name: 'PanelGroup',
  components: {
    CountTo
  },
  props: {
    countData:{
      type:Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-group {
  flex-flow: row wrap;
  .card-panel-col {
    margin-bottom: 15px;
    flex-grow: 0;

  }

  .card-panel {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    // min-width: 360px;
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
    border-color: rgba(0, 0, 0, .05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
      height: 80px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
.card-panel-description{
display: flex;
flex-flow: row nowrap;
}
.data-box{
  display: flex;
  flex-flow:column nowrap;
  
}
.data-box:nth-child(2){
  margin-left: 20px;
  position: relative;
}
.data-box:nth-child(2) ::before{
  content:'';
  position: absolute;
  top: 2px;
  left: -10px;
  width: 2px;
  height: 48px;
  background: #e4e4e4
}

@media (max-width:550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
